import "./DataCollection.css";
import InputRowGroup from "./Inputs/InputRowGroup";
import InputRow from "./Inputs/InputRow";
import TextInput from "./Inputs/TextInput";
import DropdownInput from "./Inputs/DropdownInput";
import LabeledBooleanInput from "./Inputs/LabeledBooleanInput";
import DateInput from "./Inputs/DateInput";
import { handleChange } from "../Utils/DataCollectionUtils";
import { useTranslation } from "react-i18next";
import {
    GENDERS,
    INITIAL_DEPOSIT_METHODS,
    ONGOING_DEPOSIT_METHODS, PLAN_TYPE_IDS,
    CREDIT_CARD_TYPE,
    PROVINCES,
    REQUESTED_DEPOSIT_DATES
} from "../Utils/PlanUtils";
import Description from "./Inputs/Description";

// @TODO: Add second plan
const PaymentDataCollection = ({ state }) => {
    const { t } = useTranslation();
    const plan = state.plan;
    const plan2 = state.plan2;
    const setPlan = state.setPlan;
    const setPlan2 = state.setPlan2;

    const includePlan2 = plan2.planTypeID != -1 && plan2.planTypeID != PLAN_TYPE_IDS.TRANSFER;

    const common = state.common;

    const application = state.application;
    const setApplication = state.setApplication;

    const singleOptions = [
        { label: t("Subscriber 1"), value: 1 }
    ]

    const jointOptions = [
        { label: t("Subscriber 1"), value: 1 },
        { label: t("Subscriber 2"), value: 2 }
    ]

    return (
        <form>
            <InputRowGroup label={t("First Plan Payment")}>

                {/* @TODO(Figure out how data is stored here) */}
                <InputRow label={t("Initial Deposit Method")}>
                    <DropdownInput
                        state={plan}
                        onChange={handleChange(setPlan)}
                        name="initialDepositMethod"
                        options={INITIAL_DEPOSIT_METHODS}
                        useDefaultValue={false}
                        defaultPlaceholder={t('Select option')}
                    >
                    </DropdownInput>

                </InputRow>

                {/* Initial Deposit Date */}
                {/* @TODO(Make date range derived from plan data?) */}
                <InputRow label={t("Initial Deposit Date")}>
                    <DateInput state={plan}
                        onChange={handleChange(setPlan)} name="initialDepositDate">
                    </DateInput>
                </InputRow>

                {/* Ongoing Deposit Method */}
                <InputRow label={t("Ongoing Deposit Method")}>
                    <DropdownInput
                        state={plan}
                        onChange={handleChange(setPlan)}
                        name="ongoingDepositMethod"
                        options={ONGOING_DEPOSIT_METHODS}
                        useDefaultValue={false}
                        defaultPlaceholder={t('Select option')}
                    >
                    </DropdownInput>
                </InputRow>

                {/*Requested Deposit Date*/}
                {/*only shown if ongoing payment method is PAP*/}
                {plan.ongoingDepositMethod === "PAP" &&
                    <InputRow label={t("Requested Deposit Date")}>
                        <DropdownInput
                            state={plan}
                            onChange={handleChange(setPlan)}
                            name="requestedDepositDate"
                            options={REQUESTED_DEPOSIT_DATES}
                            useDefaultValue={false}
                            defaultPlaceholder={t('Select option')}
                        >
                        </DropdownInput>
                    </InputRow>
                }
            </InputRowGroup>

            {includePlan2 &&
                <InputRowGroup label={t("Second Plan Payment")}>

                    {/* @TODO(Figure out how data is stored here) */}
                    <InputRow label={t("Initial Deposit Method")}>
                        <DropdownInput state={plan2}
                            onChange={handleChange(setPlan2)} name="initialDepositMethod" options={INITIAL_DEPOSIT_METHODS}>
                        </DropdownInput>
                    </InputRow>

                    {/* Initial Deposit Date */}
                    {/* @TODO(Make date range derived from plan data?) */}
                    <InputRow label={t("Initial Deposit Date")}>
                        <DateInput state={plan2}
                            onChange={handleChange(setPlan2)} name="initialDepositDate">
                        </DateInput>
                    </InputRow>

                    {/* Ongoing Deposit Method */}
                    <InputRow label={t("Ongoing Deposit Method")}>
                        <DropdownInput state={plan2}
                            onChange={handleChange(setPlan2)} name="ongoingDepositMethod" options={ONGOING_DEPOSIT_METHODS}>
                        </DropdownInput>
                    </InputRow>

                    {/*Requested Deposit Date*/}
                    {/*only shown if ongoing payment method is PAP*/}
                    {plan.ongoingDepositMethod === "PAP" &&
                        <InputRow label={t("Requested Deposit Date")}>
                            <DropdownInput
                                state={plan2}
                                onChange={handleChange(setPlan2)}
                                name="requestedDepositDate"
                                options={REQUESTED_DEPOSIT_DATES}
                                numberValue={true}
                            >
                            </DropdownInput>
                        </InputRow>
                    }
                </InputRowGroup>
            }

            {/*PAP*/}
            {(plan.initialDepositMethod === "PAP" || plan.ongoingDepositMethod === "PAP" || (includePlan2 && (plan2.initialDepositMethod === "PAP" || plan2.ongoingDepositMethod === "PAP"))) &&
                <InputRowGroup label={t("Pre-Authorized Payment")}>
                    <InputRow label={t("Bank Information")}>

                        {/*transit*/}
                        <TextInput
                            placeholder={t("Transit")}
                            name={"transit"}
                            state={application}
                            onChange={handleChange(setApplication)}
                            maxLength={8}
                        />

                        {/*bank*/}
                        <TextInput
                            placeholder={t("Bank")}
                            name={"bank"}
                            state={application}
                            onChange={handleChange(setApplication)}
                            maxLength={4}
                        />

                        {/*accountNumber*/}
                        <TextInput
                            placeholder={t("Account Number")}
                            name={"accountNumber"}
                            state={application}
                            onChange={handleChange(setApplication)}
                            maxLength={16}
                        />
                    </InputRow>

                    {/*bankName*/}
                    <InputRow label={t("Bank Name")}>
                        <TextInput
                            placeholder={t("Bank Name")}
                            name={"bankName"}
                            state={application}
                            onChange={handleChange(setApplication)}
                            maxLength={50}
                        />
                    </InputRow>

                    {/*Account Holder*/}
                    <InputRow label={t("Account Holder")}>
                        <DropdownInput
                            name={"papSubscriber"}
                            options={common.subscriber2Include ? jointOptions : singleOptions}
                            state={application}
                            onChange={handleChange(setApplication)}
                        />
                    </InputRow>

                    <Description label={t("If a pre-authorized debit is returned to the Depository by the bank for reason of non-sufficient funds the bank may, a the suggestion of the Depository, draw on the bank account indicated above within thirty days of such return, any amount outstanding.")} />
                </InputRowGroup>
            }

            {/*Credit Card*/}
            {(plan.initialDepositMethod === "Credit Card" || plan.ongoingDepositMethod === "Credit Card" || (includePlan2 && (plan2.initialDepositMethod === "Credit Card" || plan2.ongoingDepositMethod === "Credit Card"))) &&
                <InputRowGroup label={t("CREDIT CARD")}>
                    <InputRow label={t("Card Number")}>
                        <TextInput
                            placeholder={t("Card Number")}
                            name={"cardNumber"}
                            state={application}
                            onChange={handleChange(setApplication)}
                            maxLength={16}
                        />
                    </InputRow>

                    <InputRow label={t("Expiry")}>
                        {/*month*/}
                        <TextInput
                            placeholder={t("MM")}
                            name={"expiryMonth"}
                            state={application}
                            onChange={handleChange(setApplication)}
                            maxLength={2}
                        />

                        {/*year*/}
                        <TextInput
                            placeholder={t("YY")}
                            name={"expiryYear"}
                            state={application}
                            onChange={handleChange(setApplication)}
                            maxLength={2}
                        />
                    </InputRow>
                    <InputRow label={t("Credit Card Type")}>
                        <DropdownInput
                            state={application}
                            onChange={handleChange(setApplication)}
                            name="cardType"
                            options={CREDIT_CARD_TYPE}
                            useDefaultValue={false}
                            defaultPlaceholder={t('Select option')}
                        >
                        </DropdownInput>
                    </InputRow>

                    {/*Account Holder*/}
                    <InputRow label={t("Account Holder")}>
                        <DropdownInput
                            name={"creditSubscriber"}
                            options={common.subscriber2Include ? jointOptions : singleOptions}
                            state={application}
                            onChange={handleChange(setApplication)}
                        />
                    </InputRow>

                    <Description label={t("Processing fee of 2% for Visa and Mastercard, 3% for AMEX will apply. The applicable fee will be automatically added at the time of the processing.")} />
                </InputRowGroup>
            }

            {/*Enrollment Special Instructions*/}
            <InputRowGroup label={t("Enrolment Special Instructions")}>
                <InputRow>
                    <TextInput
                        placeholder={t("special instructions")}
                        name={"specialInstructions"}
                        state={application}
                        onChange={handleChange(setApplication)}
                        maxLength={200}
                    />
                </InputRow>
            </InputRowGroup>
        </form>
    );
};

export default PaymentDataCollection;
